import {
  OpportunityAppDataInput,
  SoldServiceAppDataModel,
} from '@user/store/opportunity'

export function parseFieldValue(
  model: SoldServiceAppDataModel,
  rawValue: string | boolean | null,
): Pick<OpportunityAppDataInput, 'valueId' | 'value'> {
  if (rawValue === null) {
    return {
      value: '',
      valueId: '',
    }
  } else if (typeof rawValue === 'boolean') {
    return {
      valueId: '',
      value: `${rawValue}`,
    }
  }

  switch (model.type) {
    case 'Dropdown':
      return {
        valueId: rawValue,
        value: model.values.find((x) => x.id === rawValue)?.name ?? '',
      }

    case 'Date':
      return {
        valueId: '',
        value: new Date(rawValue).toISOString(),
      }

    default:
      return {
        valueId: '',
        value: rawValue,
      }
  }
}
